<template>
    <div class="card_body" :style="textColors && textColors.backgroundColor ? { background: textColors.backgroundColor } : {}">
        <div :style="textColors ? { color: textColors.titleColor, backgroundColor: textColors.backgroundColor } : {}" class="card_title">
            {{ $t('agent.graphCardTitle')}}
        </div>
        <img src="@/assets/themetwo/afiliado_3.png" alt="">
        <div class="note_text" v-if="props.isShowNotice">
             {{ $t('agent.graphCardContent1')}}<span>{{ $t('agent.graphCardContent2')}}</span><br>
            {{ $t('agent.graphCardContent3')}}
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps({
    isShowNotice: {
        type: Boolean,
        default: () => false
    },
    textColors:{
        type: Object
    }
})
</script>
<style scoped>
.card_body {
    background: linear-gradient(270deg,#40294f,#3e2e4b);
    border-radius: 10px;
}

.card_title {
    color: #fd66b1;
    font-size: 15px;
    font-weight: 700;
    padding: 15px 15px 10px;
    display: flex;
    justify-content: center;
    text-align: center;
}

.card_body img {
    width: 100%;
}

.note_text {
    padding: 0 15px 15px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.85);
}

.note_text span {
    color: #FFEE00;
    padding: 0 5px;
}
</style>